export default (payload) => ({
  type: 'DELETE_HISTORY_STATE',
  payload,
});
